import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the AlertMessagePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-alert-message',
  templateUrl: 'alert-message.html',
})
export class AlertMessagePage {

  @Input() style: string;
  @Input() message: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams) {
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/alert-message/alert-message.ts